import React from 'react'
import { Switch as HeadlessSwitch } from '@headlessui/react'
import classNames from 'classnames'
import { ReactFCC } from '@/types/react'

export interface BlankSwitchProps {
  checked: boolean
  disabled?: boolean
  onChange: (enabled: boolean) => void
  knobClassName?: string
  switchClassName?: string
}

export const BlankSwitch: ReactFCC<BlankSwitchProps> = ({
  checked,
  disabled = false,
  onChange,
  knobClassName,
  switchClassName,
}) => {
  const containerClasses = checked ? 'flex-row bg-core-gray-900' : 'flex-row-reverse bg-core-gray-400'
  const animateSwitchClasses = checked
    ? 'transition-transform duration-200 translate-x-[22px]'
    : 'transition-transform duration-200 -translate-x-[22px]'

  return (
    <HeadlessSwitch
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      className={classNames(
        'relative box-content flex h-5 w-[40px] grow-0 shrink-0 items-center rounded-full',
        containerClasses,
        switchClassName,
      )}
    >
      <span
        aria-hidden="true"
        className={classNames(
          'flex box-content grow-0 shrink-0 items-center justify-center w-4 h-4 overflow-visible rounded-full bg-white',
          knobClassName,
          animateSwitchClasses,
        )}
      />
    </HeadlessSwitch>
  )
}
